// extracted by mini-css-extract-plugin
export default {"menu":"menu__mBcWL","headerTitle":"headerTitle__nldju","link":"link___c6N8","header":"header___R9tA","arrow":"arrow__labn1","backdrop":"backdrop____uc0"};